export default 'mapPage';
